<div class="uls" [class.admin-mode]="isAdminMode()">
  <comp-app-header
    [loginResponse]="loginResponse()"
    [manufacturer]="manufacturer()"
    [adminOrg]="adminOrgConfig"
    (switchTenant)="switchTenant()"
    (login)="login()"
    (logout)="logout()"
  ></comp-app-header>
  <div class="content">
    <comp-navigation></comp-navigation>
    <router-outlet></router-outlet>
  </div>
</div>
